<div id="dark" style="width: 100%; height: 100%; margin-top:120px;margin-left: 14px;margin-right: 14px;">
    <!-- gridster -->
    <div class="fab-custom">
      <button #actionButton mat-mini-fab class="action-button" [popoverClass]="'content'" [ngbPopover]="popContent" placement="right" (click)="onButtonClick()">
        <mat-icon>dashboard</mat-icon>
      </button>
      
      <ng-template #popContent>
        <button class="btn btn-sm btn-primary shadow-none dashboard-item"
          *ngFor="let item of dashboardList; let i = index" (click)="switchDashboard(i)"
          [ngClass]="i == dashboardIndex ? 'selected' : ''">
          {{ "Layout " + (i + 1) }}
          <mat-icon *ngIf="this.dashboardList.length > 1" class="remove" (click)="removeDashboard(i)">close</mat-icon>
        </button>
        <button mat-mini-fab color="secondary" class="mx-2" (click)="addNewDashboard()">
          <mat-icon>plus_one</mat-icon>
        </button>
      </ng-template>
    </div>
  
  
  
  
    <div *ngIf="companies?.length > 0 && this.accService.Ticker">
      <ngx-marquee style="direction: ltr" pauseOnHover="true" [duration]="companies.length * 2 + 's'">
        <div *ngFor="let company of companies" style="display: inline-block; cursor: pointer"
          (click)="navigateProfile(company)">
          <div style="font-size: small" class="card demo-wrap-card-bg text-color-theme">
            <div class="p-1" [ngStyle]="
                translate.currentLang == 'ar' ? { direction: 'rtl' } : ''
              ">
              <div class="d-flex justify-content-between">
                <div class="p-1 font-weight-bold demo-wrap-card-header-text" style="
                    text-overflow: ellipsis !important;
                    font-size: 14px;
                    white-space: nowrap;
                    overflow: hidden;
                  ">
                  {{ company.Reuters }}
                </div>
                <div style="font-size: 15px" class="p-1" [ngClass]="company.LAST_CHANGE_PRC > 0 ? 'green' : 'red'">
                  {{ company.LAST_CHANGE | number : "1.2-2" }} ({{
                  company.LAST_CHANGE_PRC | number : "1.2-2"
                  }}%)
  
                  <i class="ion-md-trending-up" *ngIf="company.LAST_CHANGE_PRC > 0"></i>
                  <i class="ion-md-trending-down" *ngIf="company.LAST_CHANGE_PRC < 0"></i>
                </div>
              </div>
              <div class="d-flex justify-content-between" style="max-width: 100%">
                <div class="p-1 demo-wrap-card-text" style="
                    text-overflow: ellipsis !important;
                    font-size: 14px;
                    white-space: nowrap;
                    overflow: hidden;
                  ">
                  {{
                  translate.currentLang == "en"
                  ? company.ENG_NAME
                  : company.ARB_NAME
                  }}
                </div>
                <div class="p-1 demo-wrap-card-text" style=" font-size: 15px">
                  {{ company.LAST_TRADE_PRICE | currency : "EGP" : "symbol" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ngx-marquee>
    </div>
  
  
  
  
    <ngx-flexlayout #flexlayout [layout]="dashboard" [style.height.vh]="95" [style.width.%]="99" [ngClass]="isDarktheme ?  'light-theme': 'dark-theme' " style="font-family: Cairo !important">
      <!-- Loop over the root panes -->
      <ng-container *ngFor="let pane of getAllPanes(dashboard.rootPane); let i = index">
        <!-- For each pane it gets its pane content by the slot attribute by matching the contentId in the slot attribute to contentId in the layout through the contentId map -->
        <div [attr.slot]="getSlotForPane(pane.contentId)" class="dockManagerContent">
          <!-- <div>Slot: {{ getSlotForPane(pane.contentId) }}</div> -->
          <div class="trades-news gridster-item-content">
            <!-- The dynamic component  needs to get which component it will render through the get method, then it passes the inputs we defined here, whether 
             company data or custom inputs for pane managmenet-->
            <ndc-dynamic #MWT [ndcDynamicComponent]="get(pane.headerId)" [ndcDynamicInputs]="{
              symbolCode: pane.symbolCode == null ? selectedCompanySymbol : pane.symbolCode,
              reuters: pane.reuters == null ? selectedCompanyReuters : pane.reuters,
              companyName: pane.companyName == null ? selectedCompanyName : pane.companyName,
              isLinked: true,
              state: pane.state == null ? 'Most Active' : pane.state,
              id: getSlotForPane(pane.contentId),
              name:pane.headerId,
              wasChanged:pane.wasChanged
            }">
            </ndc-dynamic>
          </div>
        </div>
      </ng-container>
  
  
      <!-- Loop over the floating panes -->
      <ng-container *ngFor="let floatingPane of dashboard.floatingPanes; let j = index">
        <ng-container *ngFor="let pane of getAllFloatingPanes(floatingPane.panes); let k = index">
          <!-- For each pane it gets its pane content by the slot attribute by matching the contentId in the slot attribute to contentId in the layout through the contentId map -->
          <div [attr.slot]="getSlotForPane(pane.contentId)" class="dockManagerContent">
            <!-- <div>Floating Pane Index: {{ j }}</div>
            <div>Pane Index: {{ k }}</div>
            <div>Slot: {{ getSlotForPane(pane.contentId) }}</div> -->
  
            <div class="trades-news gridster-item-content">
             <!-- The dynamic component  needs to get which component it will render through the get method, then it passes the inputs we defined here, whether 
             company data or custom inputs for pane managmenet-->
              <ndc-dynamic #MWT [ndcDynamicComponent]="get(pane.headerId)" [ndcDynamicInputs]="{
                symbolCode: pane.symbolCode == null ? selectedCompanySymbol : pane.symbolCode,
                reuters: pane.reuters == null ? selectedCompanyReuters : pane.reuters,
                companyName: pane.companyName == null ? selectedCompanyName : pane.companyName,
                isLinked: getIsLinkedForPane(pane.contentId),
                state: pane.state == null ? 'Most Active' : pane.state,
                id: getSlotForPane(pane.contentId),
                name:pane.headerId,
                wasChanged:pane.wasChanged
              }">
              </ndc-dynamic>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ngx-flexlayout>
  
  
  
  </div>